import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { auth } from "redux/actions/auth";
import { Wrapper, Container } from "styles/pages/notifications";
import { getNotificationDetailsApi, markNotificationReadApi } from 'redux/actions/notifications'
import * as moment from "moment";
import NotificationIcon from "assets/svg/BellIcon"
import NotificationIconWithoutRed from "assets/svg/BellIconWithoutNotification"
import { useText } from "locales/useGetText";

const Notifications = () => {
  const locale = useText("notifications");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loggedInUserInfo = JSON.parse(localStorage.getItem('loggedInUserData'))
  const clickRef = useRef(null);
  const [showNotifications, setShowNotifications] = useState(false)
  const [notificationData, setNotificationData] = useState([])
  const [unreadMsgCount, setUnreadMsgCount] = useState([])
  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState('');
  const [modalLink, setModalLink] = useState("");


  useEffect(() => {
    function handleClickOutside(event) {
      if (clickRef.current && !clickRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    fetchNotifications()
    const intervalCall = setInterval(() => {
      fetchNotifications()
    }, 10000);
    return () => clearInterval(intervalCall)
  }, []);

  const fetchNotifications = async () => {
    let response = '';
    response = await dispatch(getNotificationDetailsApi(loggedInUserInfo?.locationType, loggedInUserInfo?.customerId, loggedInUserInfo?.token))
    if (response.success) {
      let resData = response.data?.filter(val => val.title)
      let unreadMessages = resData.filter(val => val.isRead !== true).length
      setUnreadMsgCount(unreadMessages)
      setNotificationData(resData.reverse())
    } else {
      if (response?.data?.error?.message === "Invalid Token" || response.message === 'Request failed with status code 401') {
        navigate('/')
      } else {
        setAlertModalContent(response?.data?.error?.message || locale('genericError'))
        setAlertModal(!alertModal)
      }
    }
  }

  const markNotificationsRead = async () => {
    let tempData = notificationData.filter(val => val.isRead !== true).map(val => val.id)
    let response
    if (tempData.length > 0) {
      response = await dispatch(markNotificationReadApi(tempData, loggedInUserInfo?.token))
    }
  }

  const formFields = () => {
    return (
      <div
        className="nav-link"
        style={{ position: 'relative' }}
        onClick={() => {
          setShowNotifications(!showNotifications)
        }}
      >
        {unreadMsgCount > 0 ? <div onClick={markNotificationsRead}><NotificationIcon /></div> :
          <div><NotificationIconWithoutRed /></div>}
        {showNotifications && <Wrapper>
          <div className='action-popups' ref={clickRef}>
            <p className='top-arrow'></p>
            <>
              <div className='header' data-testid="Notification">
                <h6>{locale('notification')}</h6>
                {unreadMsgCount > 0 && <p>{unreadMsgCount}</p>}
              </div>
              <div style={{ maxHeight: '350px', overflowX: 'hidden', display: 'grid' }}>
                {notificationData.map((data, index) => {
                  return (
                    <>
                      <div className={data.isRead ? "row content-styles" : "row content-styles unread-msg"}>
                        <p>{data.title}</p>
                        <span>{moment(data.createdAtUtc * 1000).format("MM/DD/YYYY")}</span>
                        {(notificationData.length - 1) !== index && <hr />}
                      </div>
                    </>
                  )
                })}
              </div>
              <div style={{ height: '10px' }}></div>
            </>
          </div>
        </Wrapper>
        }
      </div>

    );
  };

  return <Container>{formFields()}</Container>;
};

export default Notifications;
